export interface SortOrderable {
    sortOrder?: number;
}

export const bySortOrder = (a: SortOrderable, b: SortOrderable) => a?.sortOrder - b?.sortOrder;

export interface CreatedOrModifiedAt {
    modifiedAt?: string;
    createdAt?: string;
}

export const byDateDesc = (a: CreatedOrModifiedAt, b: CreatedOrModifiedAt) =>
    (b.modifiedAt ?? b.createdAt ?? '').localeCompare(a.modifiedAt ?? a.createdAt ?? '');
